export enum Role {
  USERS = 'Users',
  ADMINS = 'Admins',
  RESTO_ADMINS = 'RestaurantAdmins',
}
